// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 761 ? "3706716d" : chunkId) + "." + {"427":"ded55c1089332bc0","596":"62ee3db2a1ec5025","761":"63f9900a5d8443de"}[chunkId] + ".js";
};